module.exports = __webpack_public_path__ + "static/img/2.f016663.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/2.png
// module id = Fmk+
// module chunks = 0